<template>
    <h2>404</h2>
    <h3>Page not found</h3>
</template>
